function $6767a5cce1c2be87$export$dda1d9f60106f0e9(name, props) {
    var node;
    var stack = [];
    var children = [];
    for(var i = arguments.length; i-- > 2;)stack.push(arguments[i]);
    while(stack.length){
        if (Array.isArray(node = stack.pop())) for(i = node.length; i--;)stack.push(node[i]);
        else if (null == node || true === node || false === node) ;
        else children.push(typeof node === "number" ? node + "" : node);
    }
    return typeof name === "string" ? {
        name: name,
        props: props || {},
        children: children
    } : name(props || {}, children);
}
function $6767a5cce1c2be87$export$729c8b7179294ba(state, actions, view, container) {
    var patchLock;
    var lifecycle = [];
    var root = container && container.children[0];
    var node = vnode(root, [].map);
    repaint(init([], state = copy(state), actions = copy(actions)));
    return actions;
    function vnode(element, map) {
        return element && {
            name: element.nodeName.toLowerCase(),
            props: {},
            children: map.call(element.childNodes, function(element) {
                return 3 === element.nodeType ? element.nodeValue : vnode(element, map);
            })
        };
    }
    function render(next) {
        patchLock = !patchLock;
        next = view(state, actions);
        if (container && !patchLock) root = patch(container, root, node, node = next);
        while(next = lifecycle.pop())next();
    }
    function repaint() {
        if (!patchLock) {
            patchLock = !patchLock;
            setTimeout(render);
        }
    }
    function copy(a, b) {
        var target = {};
        for(var i in a)target[i] = a[i];
        for(var i in b)target[i] = b[i];
        return target;
    }
    function set(path, value, source, target) {
        if (path.length) {
            target[path[0]] = 1 < path.length ? set(path.slice(1), value, source[path[0]], {}) : value;
            return copy(source, target);
        }
        return value;
    }
    function get(path, source) {
        for(var i = 0; i < path.length; i++)source = source[path[i]];
        return source;
    }
    function init(path, slice, actions) {
        for(var key in actions)typeof actions[key] === "function" ? function(key, action) {
            actions[key] = function(data) {
                slice = get(path, state);
                if (typeof (data = action(data)) === "function") data = data(slice, actions);
                if (data && data !== slice && !data.then) repaint(state = set(path, copy(slice, data), state, {}));
                return data;
            };
        }(key, actions[key]) : init(path.concat(key), slice[key] = slice[key] || {}, actions[key] = copy(actions[key]));
    }
    function getKey(node) {
        return node && node.props ? node.props.key : null;
    }
    function setElementProp(element, name, value, oldValue) {
        if (name === "key") ;
        else if (name === "style") for(var i in copy(oldValue, value))element[name][i] = null == value || null == value[i] ? "" : value[i];
        else {
            try {
                element[name] = null == value ? "" : value;
            } catch (_) {}
            if (typeof value !== "function") {
                if (null == value || false === value) element.removeAttribute(name);
                else element.setAttribute(name, value);
            }
        }
    }
    function createElement(node, isSVG) {
        if (typeof node === "string") var element = document.createTextNode(node);
        else {
            var element = (isSVG = isSVG || "svg" === node.name) ? document.createElementNS("http://www.w3.org/2000/svg", node.name) : document.createElement(node.name);
            if (node.props.oncreate) lifecycle.push(function() {
                node.props.oncreate(element);
            });
            for(var i = 0; i < node.children.length; i++)element.appendChild(createElement(node.children[i], isSVG));
            for(var name in node.props)setElementProp(element, name, node.props[name]);
        }
        return element;
    }
    function updateElement(element, oldProps, props) {
        for(var name in copy(oldProps, props))if (props[name] !== ("value" === name || "checked" === name ? element[name] : oldProps[name])) setElementProp(element, name, props[name], oldProps[name]);
        if (props.onupdate) lifecycle.push(function() {
            props.onupdate(element, oldProps);
        });
    }
    function removeChildren(element, node, props) {
        if (props = node.props) {
            for(var i = 0; i < node.children.length; i++)removeChildren(element.childNodes[i], node.children[i]);
            if (props.ondestroy) props.ondestroy(element);
        }
        return element;
    }
    function removeElement(parent, element, node, cb) {
        function done() {
            parent.removeChild(removeChildren(element, node));
        }
        if (node.props && (cb = node.props.onremove)) cb(element, done);
        else done();
    }
    function patch(parent, element, oldNode, node, isSVG, nextSibling) {
        if (node === oldNode) ;
        else if (null == oldNode) element = parent.insertBefore(createElement(node, isSVG), element);
        else if (node.name && node.name === oldNode.name) {
            updateElement(element, oldNode.props, node.props);
            var oldElements = [];
            var oldKeyed = {};
            var newKeyed = {};
            for(var i = 0; i < oldNode.children.length; i++){
                oldElements[i] = element.childNodes[i];
                var oldChild = oldNode.children[i];
                var oldKey = getKey(oldChild);
                if (null != oldKey) oldKeyed[oldKey] = [
                    oldElements[i],
                    oldChild
                ];
            }
            var i = 0;
            var j = 0;
            while(j < node.children.length){
                var oldChild = oldNode.children[i];
                var newChild = node.children[j];
                var oldKey = getKey(oldChild);
                var newKey = getKey(newChild);
                if (newKeyed[oldKey]) {
                    i++;
                    continue;
                }
                if (null == newKey) {
                    if (null == oldKey) {
                        patch(element, oldElements[i], oldChild, newChild, isSVG);
                        j++;
                    }
                    i++;
                } else {
                    var recyledNode = oldKeyed[newKey] || [];
                    if (oldKey === newKey) {
                        patch(element, recyledNode[0], recyledNode[1], newChild, isSVG);
                        i++;
                    } else if (recyledNode[0]) patch(element, element.insertBefore(recyledNode[0], oldElements[i]), recyledNode[1], newChild, isSVG);
                    else patch(element, oldElements[i], null, newChild, isSVG);
                    j++;
                    newKeyed[newKey] = newChild;
                }
            }
            while(i < oldNode.children.length){
                var oldChild = oldNode.children[i];
                if (null == getKey(oldChild)) removeElement(element, oldElements[i], oldChild);
                i++;
            }
            for(var i in oldKeyed)if (!newKeyed[oldKeyed[i][1].props.key]) removeElement(element, oldKeyed[i][0], oldKeyed[i][1]);
        } else if (node.name === oldNode.name) element.nodeValue = node;
        else {
            element = parent.insertBefore(createElement(node, isSVG), nextSibling = element);
            removeElement(parent, nextSibling, oldNode);
        }
        return element;
    }
}





var $08e22faa27cd48c9$export$2e2bcd8739ae039 = (str)=>{
    const items = str.split(',');
    const list = items.map((item)=>/*#__PURE__*/ (0, $6767a5cce1c2be87$export$dda1d9f60106f0e9)("li", null, item));
    return /*#__PURE__*/ (0, $6767a5cce1c2be87$export$dda1d9f60106f0e9)("ul", null, list);
};


var $6ecbd06a3a8f67cf$export$2e2bcd8739ae039 = (result)=>{
    const legal = result['Illegal?'] === 'no' ? 'LEGAL' : 'ILLEGAL';
    const dangerous = result['Dangerous?'] === 'no' ? 'SAFE' : 'NOT SAFE - DANGEROUS';
    const soldBy = result['Sold By'] ? result['Sold By'] : 'No One';
    const boughtBy = result['Bought By'] ? result['Bought By'] : 'No One';
    return /*#__PURE__*/ (0, $6767a5cce1c2be87$export$dda1d9f60106f0e9)("article", {
        class: "card"
    }, /*#__PURE__*/ (0, $6767a5cce1c2be87$export$dda1d9f60106f0e9)("h1", null, result.Name), /*#__PURE__*/ (0, $6767a5cce1c2be87$export$dda1d9f60106f0e9)("p", null, "Volume: ", result.Volume), /*#__PURE__*/ (0, $6767a5cce1c2be87$export$dda1d9f60106f0e9)("p", null, "Avg Price: ", result['Avg. Price']), /*#__PURE__*/ (0, $6767a5cce1c2be87$export$dda1d9f60106f0e9)("h4", null, "Sold By"), (0, $08e22faa27cd48c9$export$2e2bcd8739ae039)(soldBy), /*#__PURE__*/ (0, $6767a5cce1c2be87$export$dda1d9f60106f0e9)("h4", null, "Bought By"), (0, $08e22faa27cd48c9$export$2e2bcd8739ae039)(boughtBy), /*#__PURE__*/ (0, $6767a5cce1c2be87$export$dda1d9f60106f0e9)("h5", {
        class: legal === 'LEGAL' ? 'bad' : 'good'
    }, legal), /*#__PURE__*/ (0, $6767a5cce1c2be87$export$dda1d9f60106f0e9)("h5", {
        class: dangerous === 'SAFE' ? 'bad' : 'good'
    }, dangerous));
};



var $6a74858179760b95$export$2e2bcd8739ae039 = (_result, { name: name, sells: sells, buys: buys })=>{
    const sellItems = sells.map((item)=>/*#__PURE__*/ (0, $6767a5cce1c2be87$export$dda1d9f60106f0e9)("li", null, item));
    const buyItems = buys.map((item)=>/*#__PURE__*/ (0, $6767a5cce1c2be87$export$dda1d9f60106f0e9)("li", null, item));
    return /*#__PURE__*/ (0, $6767a5cce1c2be87$export$dda1d9f60106f0e9)("section", {
        class: "stations"
    }, /*#__PURE__*/ (0, $6767a5cce1c2be87$export$dda1d9f60106f0e9)("h1", null, name), /*#__PURE__*/ (0, $6767a5cce1c2be87$export$dda1d9f60106f0e9)("h4", null, "Sells:"), sellItems.length > 0 ? /*#__PURE__*/ (0, $6767a5cce1c2be87$export$dda1d9f60106f0e9)("ul", null, sellItems) : 'N/A', /*#__PURE__*/ (0, $6767a5cce1c2be87$export$dda1d9f60106f0e9)("h4", null, "Buys"), buyItems.length > 0 ? /*#__PURE__*/ (0, $6767a5cce1c2be87$export$dda1d9f60106f0e9)("ul", null, buyItems) : 'N/A');
};


const $b66147a275019090$var$resultsLoader = (Comp)=>(results, data)=>results.map((result)=>Comp(result, data));
const $b66147a275019090$var$goodInput = (handler)=>/*#__PURE__*/ (0, $6767a5cce1c2be87$export$dda1d9f60106f0e9)("input", {
        onkeyup: handler,
        placeholder: "type stuff here"
    });
const $b66147a275019090$var$stationInput = (handler)=>/*#__PURE__*/ (0, $6767a5cce1c2be87$export$dda1d9f60106f0e9)("input", {
        onkeyup: handler,
        placeholder: "type stuff here"
    });
var $b66147a275019090$export$2e2bcd8739ae039 = ({ goodSearch: goodSearch, results: results, sells: sells, buys: buys, name: name }, { searchGoods: searchGoods, searchStations: searchStations, bitFlip: bitFlip })=>/*#__PURE__*/ (0, $6767a5cce1c2be87$export$dda1d9f60106f0e9)("div", {
        class: "counter"
    }, /*#__PURE__*/ (0, $6767a5cce1c2be87$export$dda1d9f60106f0e9)("h3", null, "Filter ", goodSearch ? 'Goods' : 'Stations'), /*#__PURE__*/ (0, $6767a5cce1c2be87$export$dda1d9f60106f0e9)("br", null), /*#__PURE__*/ (0, $6767a5cce1c2be87$export$dda1d9f60106f0e9)("button", {
        onclick: bitFlip
    }, goodSearch ? 'Switch to Station Search by name' : 'Switch to Good Search by name'), /*#__PURE__*/ (0, $6767a5cce1c2be87$export$dda1d9f60106f0e9)("br", null), /*#__PURE__*/ (0, $6767a5cce1c2be87$export$dda1d9f60106f0e9)("br", null), goodSearch ? $b66147a275019090$var$goodInput(searchGoods) : $b66147a275019090$var$stationInput(searchStations), /*#__PURE__*/ (0, $6767a5cce1c2be87$export$dda1d9f60106f0e9)("section", null, goodSearch ? $b66147a275019090$var$resultsLoader((0, $6ecbd06a3a8f67cf$export$2e2bcd8739ae039))(results, null) : $b66147a275019090$var$resultsLoader((0, $6a74858179760b95$export$2e2bcd8739ae039))([
        null
    ], {
        name: name,
        sells: sells,
        buys: buys
    })));


var $cb43442e0564302c$export$2e2bcd8739ae039 = [
    {
        "Name": "Acid",
        "Volume": "1",
        "Avg. Price": "402",
        "Sold By": "Chemical Factory, Rubber Factory",
        "Bought By": "Explosive Charge Factory, Paint Manufacturer",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Acron Drug",
        "Volume": "0.1",
        "Avg. Price": "6000",
        "Sold By": "",
        "Bought By": "",
        "Illegal?": "yes",
        "Dangerous?": "no"
    },
    {
        "Name": "Adhesive",
        "Volume": "0.25",
        "Avg. Price": "402",
        "Sold By": "Chemical Factory",
        "Bought By": "Ammunition Factory, Explosive Charge Factory, High Pressure Tube Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Aluminum",
        "Volume": "1",
        "Avg. Price": "200",
        "Sold By": "Aluminum Mine",
        "Bought By": "Ammunition Factory, Gun Factory, High Pressure Tube Factory, Laser Head Factory, Servo Factory, Steel Tube Factory, Shipyard, Tools Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Ammunition",
        "Volume": "3",
        "Avg. Price": "3786",
        "Sold By": "Ammunition Factory",
        "Bought By": "Equipment Dock, Gun Factory, Military Outpost",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Ammunition L",
        "Volume": "2.5",
        "Avg. Price": "422",
        "Sold By": "Ammunition Factory",
        "Bought By": "Equipment Dock, Military Outpost",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Ammunition M",
        "Volume": "1.5",
        "Avg. Price": "422",
        "Sold By": "Ammunition Factory",
        "Bought By": "Equipment Dock, Military Outpost",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Ammunition S",
        "Volume": "0.5",
        "Avg. Price": "422",
        "Sold By": "Ammunition Factory",
        "Bought By": "Equipment Dock, Military Outpost",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Antigrav Generator",
        "Volume": "2.5",
        "Avg. Price": "71632",
        "Sold By": "Antigrav Generator Factory",
        "Bought By": "Equipment Dock, Research Station, Shipyard",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Antigrav Unit",
        "Volume": "2.5",
        "Avg. Price": "25391",
        "Sold By": "Antigrav Unit Factory",
        "Bought By": "Antigrav Generator Factory, Body Armor Factory, Vehicle Factory, Teleporter Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Beer",
        "Volume": "0.5",
        "Avg. Price": "216",
        "Sold By": "Brewery",
        "Bought By": "Casino, Habitat",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Bio Gas",
        "Volume": "1",
        "Avg. Price": "213",
        "Sold By": "Cattle Ranch, Fish Farm, Sheep Ranch",
        "Bought By": "Chemical Factory, Fungus Farm, Plasma Cell Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Body Armor",
        "Volume": "1.5",
        "Avg. Price": "95906",
        "Sold By": "Body Armor Factory",
        "Bought By": "Military Outpost",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Book",
        "Volume": "0.2",
        "Avg. Price": "319",
        "Sold By": "Book Factory",
        "Bought By": "Habitat",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Carbon",
        "Volume": "1",
        "Avg. Price": "423",
        "Sold By": "Carbon Extractor, Planetary Trading Post",
        "Bought By": "Body Armor Factory, Chemical Factory, High Capacity Lens Factory, High Pressure Tube Factory, Steel Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Cattle",
        "Volume": "1.5",
        "Avg. Price": "254",
        "Sold By": "Cattle Ranch",
        "Bought By": "Biotope, Dairy Farm, Meat Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Chemicals",
        "Volume": "1",
        "Avg. Price": "402",
        "Sold By": "Chemical Factory",
        "Bought By": "Ammunition Factory, Explosive Charge Factory, Fertilizer Factory, Medical Supplies Factory, Paint Manufacturer, Warhead Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Chlorine",
        "Volume": "1",
        "Avg. Price": "150",
        "Sold By": "Gas Collector",
        "Bought By": "Medical Supplies Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Clothes",
        "Volume": "1",
        "Avg. Price": "102",
        "Sold By": "Clothes Factory",
        "Bought By": "",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Coal",
        "Volume": "2",
        "Avg. Price": "200",
        "Sold By": "Coal Mine",
        "Bought By": "Biotope, Steel Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Cocoa",
        "Volume": "0.2",
        "Avg. Price": "87",
        "Sold By": "Cocoa Farm",
        "Bought By": "Habitat",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Coffee",
        "Volume": "0.2",
        "Avg. Price": "187",
        "Sold By": "Coffee Farm",
        "Bought By": "Habitat",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Computation Mainframe",
        "Volume": "1",
        "Avg. Price": "37940",
        "Sold By": "Computation Mainframe Factory",
        "Bought By": "Shipyard",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Conductor",
        "Volume": "0.15",
        "Avg. Price": "168",
        "Sold By": "Conductor Factory",
        "Bought By": "Accelerator Factory, Electro Magnet Factory, Energy Generator Factory, Energy Inverter Factory, Laser Head Factory, Servo Factory, Targeting System Factory, Teleporter Factory, Warhead Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Coolant",
        "Volume": "0.5",
        "Avg. Price": "402",
        "Sold By": "Chemical Factory",
        "Bought By": "Body Armor Factory, Mining Robot Factory, Turbine Factory, War Robot Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Copper",
        "Volume": "1",
        "Avg. Price": "350",
        "Sold By": "Copper Mine, Planetary Trading Post",
        "Bought By": "Computer Component Factory, Electro Magnet Factory, Processor Factory, Targeting Card Factory, Tesla Coil Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Corn",
        "Volume": "1",
        "Avg. Price": "28",
        "Sold By": "Corn Farm",
        "Bought By": "Biotope, Carbon Extractor, Cattle Ranch, Food Bar Factory, Food Factory, Sheep Ranch",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Crystal",
        "Volume": "1.5",
        "Avg. Price": "190",
        "Sold By": "Crystal Farm",
        "Bought By": "Glass Manufacturer, Nanobot Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Dairy",
        "Volume": "1",
        "Avg. Price": "19",
        "Sold By": "Dairy Farm",
        "Bought By": "Protein Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Diamond",
        "Volume": "0.05",
        "Avg. Price": "750",
        "Sold By": "Trading Post",
        "Bought By": "Drill Factory, High Capacity Lens Factory, Jewelry Manufacturer",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Display",
        "Volume": "1",
        "Avg. Price": "7858",
        "Sold By": "Computer Component Factory, Display Factory",
        "Bought By": "Computation Mainframe Factory, Mining Robot Factory, Satellite Factory, Shipyard, Vehicle Factory, War Robot Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Drill",
        "Volume": "20",
        "Avg. Price": "20443",
        "Sold By": "Drill Factory",
        "Bought By": "Mining Robot Factory, Planetary Trading Post, Research Station, Equipment Dock",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Drone",
        "Volume": "10",
        "Avg. Price": "7754",
        "Sold By": "Drone Factory",
        "Bought By": "Equipment Dock, Planetary Trading Post",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Electro Magnet",
        "Volume": "0.75",
        "Avg. Price": "483",
        "Sold By": "Electro Magnet Factory",
        "Bought By": "Antigrav Generator Factory, Electromagnetic Charge Factory, Force Generator Factory, Gauss Rail Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Electromagnetic Charge",
        "Volume": "1",
        "Avg. Price": "13985",
        "Sold By": "Electromagnetic Charge Factory",
        "Bought By": "Military Outpost",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Electron Accelerator",
        "Volume": "12",
        "Avg. Price": "125431",
        "Sold By": "Accelerator Factory",
        "Bought By": "Research Station",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Energy Cell",
        "Volume": "1",
        "Avg. Price": "50",
        "Sold By": "Solar Power Plant",
        "Bought By": "Ammunition Factory, Antigrav Unit Factory, Book Factory, Chemical Factory, Cocoa Farm, Coffee Farm, Conductor Factory, Corn Farm, Distillery, Energy Container Factory, Energy Generator Factory, Energy Tube Factory, Explosive Charge Factory, Fertilizer Factory, Food Bar Factory, Fruit Farm, Fuel Factory, Gauss Rail Factory, Laser Head Factory, Laser Modulator Factory, Luxury Food Factory, Microchip Factory, Oil Refinery, Planetary Trading Post, Plant Farm, Plasma Cell Factory, Plastic Manufacturer, Potato Farm, Power Unit Factory, Rice Farm, Rubber Factory, Semi Conductor Manufacturer, Sheep Ranch, Solar Cell Factory, Spices Farm, Targeting System Factory, Tea Farm, Tools Factory, Transformator Factory, Vegetable Farm, Wheat Farm, Wood Farm",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Energy Container",
        "Volume": "4.5",
        "Avg. Price": "1087",
        "Sold By": "Energy Container Factory",
        "Bought By": "Electromagnetic Charge Factory, Satellite Factory, Shipyard",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Energy Generator",
        "Volume": "2",
        "Avg. Price": "15957",
        "Sold By": "Energy Generator Factory",
        "Bought By": "Antigrav Generator Factory, Force Generator Factory, Planetary Trading Post, Vehicle Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Energy Inverter",
        "Volume": "3",
        "Avg. Price": "1277",
        "Sold By": "Energy Inverter Factory, Turret Factory",
        "Bought By": "",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Energy Tube",
        "Volume": "1.5",
        "Avg. Price": "2895",
        "Sold By": "Energy Tube Factory",
        "Bought By": "Accelerator Factory, Electromagnetic Charge Factory, Energy Inverter Factory, Fusion Core Factory, Gauss Rail Factory, Laser Compressor Factory, Laser Modulator Factory, Shipyard",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Explosive Charge",
        "Volume": "1.5",
        "Avg. Price": "1423",
        "Sold By": "Explosive Charge Factory",
        "Bought By": "Military Outpost, Planetary Trading Post",
        "Illegal?": "no",
        "Dangerous?": "yes"
    },
    {
        "Name": "Fabric",
        "Volume": "1",
        "Avg. Price": "91",
        "Sold By": "Fabric Factory, Sheep Ranch",
        "Bought By": "Clothes Factory, Medical Supplies Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Fertilizer",
        "Volume": "1",
        "Avg. Price": "319",
        "Sold By": "Fertilizer Factory",
        "Bought By": "Cocoa Farm, Coffee Farm, Spices Farm",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Fish",
        "Volume": "0.5",
        "Avg. Price": "152",
        "Sold By": "Fish Farm",
        "Bought By": "",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Fluorine",
        "Volume": "1",
        "Avg. Price": "250",
        "Sold By": "Gas Collector",
        "Bought By": "Explosive Charge Factory, Fuel Factory",
        "Illegal?": "no",
        "Dangerous?": "yes"
    },
    {
        "Name": "Food",
        "Volume": "0.5",
        "Avg. Price": "300",
        "Sold By": "Food Factory",
        "Bought By": "Biotope, Casino, Habitat",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Food Bar",
        "Volume": "0.5",
        "Avg. Price": "223",
        "Sold By": "Food Bar Factory",
        "Bought By": "Biotope, Military Outpost",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Force Generator",
        "Volume": "4",
        "Avg. Price": "49576",
        "Sold By": "Force Generator Factory",
        "Bought By": "Research Station, Repair Dock",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Fruit",
        "Volume": "0.5",
        "Avg. Price": "56",
        "Sold By": "Fruit Farm",
        "Bought By": "Habitat, Luxury Food Factory, Wine Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Fuel",
        "Volume": "1",
        "Avg. Price": "1232",
        "Sold By": "Fuel Factory",
        "Bought By": "Drone Factory, Equipment Dock, Planetary Trading Post, Repair Dock, Rocket Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Fungus",
        "Volume": "1",
        "Avg. Price": "46",
        "Sold By": "Fungus Farm",
        "Bought By": "Biotope, Brewery, Wine Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Fusion Core",
        "Volume": "2.5",
        "Avg. Price": "5114",
        "Sold By": "Fusion Core Factory",
        "Bought By": "Equipment Dock, Fusion Generator Factory, Tesla Coil Factory, Shipyard",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Fusion Generator",
        "Volume": "2.5",
        "Avg. Price": "39553",
        "Sold By": "Fusion Generator Factory",
        "Bought By": "Accelerator Factory, Research Station",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Gauss Rail",
        "Volume": "2",
        "Avg. Price": "7735",
        "Sold By": "Gauss Rail Factory",
        "Bought By": "Accelerator Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Gems",
        "Volume": "0.05",
        "Avg. Price": "400",
        "Sold By": "Planetary Trading Post",
        "Bought By": "Jewelry Manufacturer",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Glass",
        "Volume": "1",
        "Avg. Price": "182",
        "Sold By": "Glass Manufacturer",
        "Bought By": "Biotope, Display Factory, High Capacity Lens Factory, Laser Head Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Gold",
        "Volume": "0.5",
        "Avg. Price": "600",
        "Sold By": "Noble Metal Mine, Planetary Trading Post",
        "Bought By": "Computer Component Factory, Conductor Factory, Fusion Core Factory, Jewelry Manufacturer, Processor Factory, Semi Conductor Manufacturer, Solar Cell Factory, Wire Manufacturer",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Gun",
        "Volume": "0.5",
        "Avg. Price": "1232",
        "Sold By": "Gun Factory",
        "Bought By": "Military Outpost, War Robot Factory",
        "Illegal?": "no",
        "Dangerous?": "yes"
    },
    {
        "Name": "Helium",
        "Volume": "1",
        "Avg. Price": "50",
        "Sold By": "Gas Collector",
        "Bought By": "Plasma Cell Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "High Capacity Lens",
        "Volume": "1",
        "Avg. Price": "4689",
        "Sold By": "High Capacity Lens Factory",
        "Bought By": "Research Station",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "High Pressure Tube",
        "Volume": "2",
        "Avg. Price": "1650",
        "Sold By": "High Pressure Tube Factory",
        "Bought By": "Accelerator Factory, Gauss Rail Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Hydrogen",
        "Volume": "1",
        "Avg. Price": "150",
        "Sold By": "Gas Collector",
        "Bought By": "Chemical Factory, Fusion Core Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Industrial Tesla Coil",
        "Volume": "5.5",
        "Avg. Price": "10314",
        "Sold By": "Tesla Coil Factory",
        "Bought By": "Shipyard",
        "Illegal?": "no",
        "Dangerous?": "yes"
    },
    {
        "Name": "Jewelry",
        "Volume": "0.2",
        "Avg. Price": "1260",
        "Sold By": "Jewelry Manufacturer",
        "Bought By": "",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Laser Compressor",
        "Volume": "1.5",
        "Avg. Price": "6577",
        "Sold By": "Laser Compressor Factory",
        "Bought By": "Equipment Dock",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Laser Head",
        "Volume": "2",
        "Avg. Price": "4690",
        "Sold By": "Laser Head Factory",
        "Bought By": "Drill Factory, Equipment Dock",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Laser Modulator",
        "Volume": "3",
        "Avg. Price": "16742",
        "Sold By": "Laser Modulator Factory",
        "Bought By": "",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Lead",
        "Volume": "1",
        "Avg. Price": "200",
        "Sold By": "Lead Mine, Planetary Trading Post",
        "Bought By": "Ammunition Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Leather",
        "Volume": "0.5",
        "Avg. Price": "37",
        "Sold By": "Dairy Farm, Meat Factory",
        "Bought By": "Habitat",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Liquor",
        "Volume": "1.25",
        "Avg. Price": "1867",
        "Sold By": "Distillery",
        "Bought By": "Casino, Habitat",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Luxury Food",
        "Volume": "2.5",
        "Avg. Price": "6452",
        "Sold By": "Luxury Food Factory",
        "Bought By": "Casino",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Meat",
        "Volume": "0.5",
        "Avg. Price": "37",
        "Sold By": "Meat Factory",
        "Bought By": "Food Factory, Habitat, Protein Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Medical Supplies",
        "Volume": "1",
        "Avg. Price": "3006",
        "Sold By": "Medical Supplies Factory",
        "Bought By": "Casino, Military Outpost, Repair Dock, Shipyard",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Metal Plate",
        "Volume": "3",
        "Avg. Price": "792",
        "Sold By": "Metal Plate Factory",
        "Bought By": "Body Armor Factory, Drone Factory, Repair Dock, Shipyard, Teleporter Factory, Vehicle Factory, Warhead Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Microchip",
        "Volume": "0.1",
        "Avg. Price": "896",
        "Sold By": "Microchip Factory",
        "Bought By": "Computation Mainframe Factory, Computer Component Factory, Display Factory, Energy Generator Factory, Processor Factory, Rocket Factory, Targeting Card Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Military Tesla Coil",
        "Volume": "4.5",
        "Avg. Price": "10314",
        "Sold By": "Tesla Coil Factory",
        "Bought By": "Military Outpost",
        "Illegal?": "no",
        "Dangerous?": "yes"
    },
    {
        "Name": "Mineral",
        "Volume": "1.5",
        "Avg. Price": "500",
        "Sold By": "Mineral Extractor, Planetary Trading Post",
        "Bought By": "Fertilizer Factory, Fungus Farm",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Mining Robot",
        "Volume": "8",
        "Avg. Price": "145977",
        "Sold By": "Mining Robot Factory",
        "Bought By": "Planetary Trading Post",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Morn Drug",
        "Volume": "0.1",
        "Avg. Price": "5000",
        "Sold By": "",
        "Bought By": "",
        "Illegal?": "yes",
        "Dangerous?": "no"
    },
    {
        "Name": "Nanobot",
        "Volume": "0.5",
        "Avg. Price": "1338",
        "Sold By": "Nanobot Factory",
        "Bought By": "Body Armor Factory, Force Generator Factory, Mining Robot Factory, Repair Dock, War Robot Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Neon",
        "Volume": "1",
        "Avg. Price": "200",
        "Sold By": "Gas Collector",
        "Bought By": "Energy Tube Factory, Plasma Cell Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Neutron Accelerator",
        "Volume": "15",
        "Avg. Price": "125431",
        "Sold By": "Accelerator Factory",
        "Bought By": "Research Station",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Nitrogen",
        "Volume": "1",
        "Avg. Price": "40",
        "Sold By": "Gas Collector",
        "Bought By": "Chemical Factory, Fuel Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Oil",
        "Volume": "1",
        "Avg. Price": "490",
        "Sold By": "Oil Refinery",
        "Bought By": "Fuel Factory, Paint Manufacturer, Plastic Manufacturer, Rubber Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Ore",
        "Volume": "2",
        "Avg. Price": "70",
        "Sold By": "Ore Mine, Planetary Trading Post",
        "Bought By": "Glass Manufacturer, Steel Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Oxygen",
        "Volume": "1",
        "Avg. Price": "80",
        "Sold By": "Cocoa Farm, Coffee Farm, Corn Farm, Fruit Farm, Gas Collector, Plant Farm, Potato Farm, Rice Farm, Spices Farm, Tea Farm, Vegetable Farm, Wheat Farm, Wood Farm",
        "Bought By": "Cattle Ranch, Chemical Factory, Fish Farm, Repair Dock, Sheep Ranch",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Paint",
        "Volume": "1",
        "Avg. Price": "481",
        "Sold By": "Paint Manufacturer",
        "Bought By": "Ammunition Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Paper",
        "Volume": "1",
        "Avg. Price": "46",
        "Sold By": "Paper Factory",
        "Bought By": "Book Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Plankton",
        "Volume": "1",
        "Avg. Price": "50",
        "Sold By": "Fish Farm, Plankton Collector",
        "Bought By": "Fertilizer Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Plant",
        "Volume": "1.5",
        "Avg. Price": "14",
        "Sold By": "Plant Farm",
        "Bought By": "Biotope",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Plasma Cell",
        "Volume": "0.25",
        "Avg. Price": "174",
        "Sold By": "Plasma Cell Factory",
        "Bought By": "Accelerator Factory, Display Factory, Drone Factory, Fusion Core Factory, Fusion Generator Factory, Laser Compressor Factory, Power Unit Factory, Teleporter Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Plastic",
        "Volume": "0.5",
        "Avg. Price": "137",
        "Sold By": "Plastic Manufacturer",
        "Bought By": "Energy Tube Factory, Explosive Charge Factory, Force Generator Factory, Gun Factory, High Capacity Lens Factory, Servo Factory, Tesla Coil Factory, Transformator Factory, Wire Manufacturer",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Platinum",
        "Volume": "0.5",
        "Avg. Price": "750",
        "Sold By": "Noble Metal Mine",
        "Bought By": "Computer Component Factory, Conductor Factory, Energy Tube Factory, Jewelry Manufacturer, Processor Factory, Solar Cell Factory, Tools Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Potato",
        "Volume": "1",
        "Avg. Price": "24",
        "Sold By": "Potato Farm",
        "Bought By": "Carbon Extractor",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Power Unit",
        "Volume": "5",
        "Avg. Price": "1211",
        "Sold By": "Power Unit Factory",
        "Bought By": "Antigrav Unit Factory, Computation Mainframe Factory, Fusion Generator Factory, Mining Robot Factory, Teleporter Factory, Turbine Factory, Vehicle Factory, War Robot Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Processor",
        "Volume": "0.1",
        "Avg. Price": "7858",
        "Sold By": "Computer Component Factory, Processor Factory",
        "Bought By": "Antigrav Unit Factory, Computation Mainframe Factory, Drill Factory, Mining Robot Factory, Satellite Factory, Targeting Card Factory, Targeting System Factory, War Robot Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Protein",
        "Volume": "0.1",
        "Avg. Price": "34",
        "Sold By": "Protein Factory",
        "Bought By": "",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Proton Accelerator",
        "Volume": "15",
        "Avg. Price": "125431",
        "Sold By": "Accelerator Factory",
        "Bought By": "Research Station",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Raw Oil",
        "Volume": "1",
        "Avg. Price": "150",
        "Sold By": "Oil Rig, Planetary Trading Post",
        "Bought By": "Oil Refinery",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Rice",
        "Volume": "1",
        "Avg. Price": "15",
        "Sold By": "Rice Farm",
        "Bought By": "Biotope, Carbon Extractor, Food Bar Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Rocket",
        "Volume": "4",
        "Avg. Price": "11250",
        "Sold By": "Rocket Factory",
        "Bought By": "Equipment Dock",
        "Illegal?": "no",
        "Dangerous?": "yes"
    },
    {
        "Name": "Rubber",
        "Volume": "1",
        "Avg. Price": "686",
        "Sold By": "Rubber Factory",
        "Bought By": "Vehicle Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Satellite",
        "Volume": "15",
        "Avg. Price": "65714",
        "Sold By": "Satellite Factory",
        "Bought By": "Equipment Dock, Research Station",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Scrap Metal",
        "Volume": "3",
        "Avg. Price": "25",
        "Sold By": "Drill Factory, Drone Factory, Laser Compressor Factory, Mining Robot Factory, Satellite Factory, Scrap Metal Trader, Teleporter Factory, Vehicle Factory, War Robot Factory, Warhead Factory",
        "Bought By": "Steel Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Semi Conductor",
        "Volume": "0.1",
        "Avg. Price": "129",
        "Sold By": "Semi Conductor Manufacturer",
        "Bought By": "Computer Component Factory, Display Factory, Microchip Factory, Nanobot Factory, Processor Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Servo",
        "Volume": "0.25",
        "Avg. Price": "1387",
        "Sold By": "Servo Factory",
        "Bought By": "Antigrav Generator Factory, Laser Modulator Factory, Turbine Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Sheep",
        "Volume": "1",
        "Avg. Price": "130",
        "Sold By": "Sheep Ranch",
        "Bought By": "Biotope, Fabric Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Silicon",
        "Volume": "1",
        "Avg. Price": "500",
        "Sold By": "Silicon Mine, Planetary Trading Post",
        "Bought By": "Semi Conductor Manufacturer, Solar Cell Factory, Transformator Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Silver",
        "Volume": "0.5",
        "Avg. Price": "300",
        "Sold By": "Noble Metal Mine",
        "Bought By": "Metal Plate Factory, Tools Factory, Transformator Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Slave",
        "Volume": "1",
        "Avg. Price": "15000",
        "Sold By": "",
        "Bought By": "",
        "Illegal?": "yes",
        "Dangerous?": "no"
    },
    {
        "Name": "Solar Cell",
        "Volume": "2",
        "Avg. Price": "469",
        "Sold By": "Solar Cell Factory",
        "Bought By": "Solar Panel Factory, Repair Dock, Shipyard",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Solar Panel",
        "Volume": "6",
        "Avg. Price": "6858",
        "Sold By": "Solar Panel Factory",
        "Bought By": "Planetary Trading Post, Repair Dock, Satellite Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Solvent",
        "Volume": "1",
        "Avg. Price": "402",
        "Sold By": "Chemical Factory",
        "Bought By": "Fertilizer Factory, Paint Manufacturer",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Spices",
        "Volume": "0.3",
        "Avg. Price": "268",
        "Sold By": "Spices Farm",
        "Bought By": "Habitat, Luxury Food Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Steel",
        "Volume": "1",
        "Avg. Price": "277",
        "Sold By": "Steel Factory",
        "Bought By": "Ammunition Factory, Conductor Factory, Drill Factory, Electro Magnet Factory, Energy Tube Factory, Explosive Charge Factory, Force Generator Factory, Fusion Generator Factory, Gun Factory, High Pressure Tube Factory, Metal Plate Factory, Plasma Cell Factory, Repair Dock, Rocket Factory, Semi Conductor Manufacturer, Servo Factory, Steel Tube Factory, Tesla Coil Factory, Tools Factory, Transformator Factory, Turbine Factory, Wire Manufacturer",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Steel Tube",
        "Volume": "3",
        "Avg. Price": "704",
        "Sold By": "Steel Tube Factory",
        "Bought By": "Energy Tube Factory, High Pressure Tube Factory, Satellite Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Targeting Card",
        "Volume": "0.5",
        "Avg. Price": "11873",
        "Sold By": "Computer Component Factory, Targeting Card Factory",
        "Bought By": "Targeting System Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Targeting System",
        "Volume": "0.75",
        "Avg. Price": "29674",
        "Sold By": "Targeting System Factory",
        "Bought By": "Military Outpost",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Tea",
        "Volume": "0.2",
        "Avg. Price": "37",
        "Sold By": "Tea Farm",
        "Bought By": "Habitat",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Teleporter",
        "Volume": "12",
        "Avg. Price": "39365",
        "Sold By": "Teleporter Factory",
        "Bought By": "Body Armor Factory, Mining Robot Factory, War Robot Factory, Research Station",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Tools",
        "Volume": "0.4",
        "Avg. Price": "214",
        "Sold By": "Tools Factory",
        "Bought By": "Equipment Dock, Planetary Trading Post",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Toxic Waste",
        "Volume": "4",
        "Avg. Price": "15",
        "Sold By": "Ammunition Factory, Fertilizer Factory, Fuel Factory, Fungus Farm, Laser Head Factory, Paint Manufacturer, Rubber Factory",
        "Bought By": "",
        "Illegal?": "no",
        "Dangerous?": "yes"
    },
    {
        "Name": "Transformator",
        "Volume": "0.2",
        "Avg. Price": "209",
        "Sold By": "Transformator Factory",
        "Bought By": "Electro Magnet Factory, Electromagnetic Charge Factory, Energy Container Factory, Energy Inverter Factory, Fusion Core Factory, Gauss Rail Factory, Laser Compressor Factory, Laser Modulator Factory, Power Unit Factory, Solar Panel Factory, Teleporter Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Turbine",
        "Volume": "7.5",
        "Avg. Price": "16729",
        "Sold By": "Turbine Factory",
        "Bought By": "Accelerator Factory, Research Station, Shipyard",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Vegetable",
        "Volume": "1",
        "Avg. Price": "32",
        "Sold By": "Vegetable Farm",
        "Bought By": "Biotope, Food Factory, Habitat",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Vehicle",
        "Volume": "25",
        "Avg. Price": "77087",
        "Sold By": "Vehicle Factory",
        "Bought By": "Military Outpost",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "War Robot",
        "Volume": "8",
        "Avg. Price": "92186",
        "Sold By": "War Robot Factory",
        "Bought By": "Military Outpost",
        "Illegal?": "no",
        "Dangerous?": "yes"
    },
    {
        "Name": "Warhead",
        "Volume": "3",
        "Avg. Price": "5630",
        "Sold By": "Warhead Factory",
        "Bought By": "Equipment Dock, Rocket Factory",
        "Illegal?": "no",
        "Dangerous?": "yes"
    },
    {
        "Name": "Water",
        "Volume": "0.35",
        "Avg. Price": "20",
        "Sold By": "Ice Mine, Water Collector",
        "Bought By": "Biotope, Brewery, CasinoCattle Ranch",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Wheat",
        "Volume": "1",
        "Avg. Price": "23",
        "Sold By": "Wheat Farm",
        "Bought By": "BiotopeBrewery",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Wine",
        "Volume": "0.5",
        "Avg. Price": "182",
        "Sold By": "Wine Factory",
        "Bought By": "Casino, Luxury Food Factory, Habitat",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Wire",
        "Volume": "0.5",
        "Avg. Price": "95",
        "Sold By": "Wire Manufacturer",
        "Bought By": "Antigrav Generator Factory, Computation Mainframe Factory, Computer Component Factory, Laser Compressor Factory, Microchip Factory, Repair Dock, Targeting System Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Wood",
        "Volume": "2.5",
        "Avg. Price": "350",
        "Sold By": "Wood Farm",
        "Bought By": "Biotope, Habitat, Paper Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    },
    {
        "Name": "Zinc",
        "Volume": "1",
        "Avg. Price": "250",
        "Sold By": "Zinc Mine",
        "Bought By": "Conductor Factory, Medical Supplies Factory, Solar Cell Factory",
        "Illegal?": "no",
        "Dangerous?": "no"
    }
];


const $35da740d59af89ba$var$findAlikes = (searchTerm)=>{
    const match = (good)=>(term)=>good.Name.toLowerCase().includes(term);
    return (good)=>match(good)(searchTerm);
};
const $35da740d59af89ba$var$state = {
    goods: (0, $cb43442e0564302c$export$2e2bcd8739ae039),
    results: (0, $cb43442e0564302c$export$2e2bcd8739ae039).map((e)=>e),
    goodSearch: true,
    sells: [],
    buys: [],
    name: ''
};
const $35da740d59af89ba$var$actions = {
    searchGoods: ({ target: target })=>({ goods: goods })=>{
            const searchTerm = target.value.trim().toLowerCase();
            const results = goods.filter($35da740d59af89ba$var$findAlikes(searchTerm));
            return {
                results: results
            };
        },
    searchStations: ({ target: target })=>({ goods: goods })=>{
            const searchTerm = target.value.trim().toLowerCase();
            if (searchTerm === '') return {
                name: '',
                sells: [],
                buys: []
            };
            const sells = [];
            const buys = [];
            const names = [];
            goods.forEach((good)=>{
                const soldByStations = good['Sold By'].toLowerCase();
                const boughtByStations = good['Bought By'].toLowerCase();
                if (soldByStations.includes(searchTerm)) {
                    sells.push(good.Name);
                    soldByStations.split(', ').forEach((station)=>{
                        if (station.includes(searchTerm)) names.push(station);
                    });
                }
                if (boughtByStations.includes(searchTerm)) {
                    buys.push(good.Name);
                    boughtByStations.split(', ').forEach((station)=>{
                        if (station.includes(searchTerm)) names.push(station);
                    });
                }
            });
            const uniqueNames = Array.from(new Set(names));
            return {
                name: uniqueNames.join(', '),
                sells: sells,
                buys: buys
            };
        },
    bitFlip () {
        return ({ goodSearch: goodSearch })=>({
                goodSearch: !goodSearch
            });
    }
};
(0, $6767a5cce1c2be87$export$729c8b7179294ba)($35da740d59af89ba$var$state, $35da740d59af89ba$var$actions, (0, $b66147a275019090$export$2e2bcd8739ae039), document.body);


//# sourceMappingURL=avorion.67b18c9c.js.map
